import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Card } from 'antd';
import { BigAlert } from 'components/Alerts';
import { Link } from 'react-router-dom';
import { txt } from 'libs/i18n';
const MissingSubpage = ({ backLink, backName }) => (_jsx(Card, { children: _jsx(BigAlert, { header: txt('wrongHive'), body: (_jsxs(_Fragment, { children: [_jsx("p", { children: txt('pageNotFound') }), _jsx(Link, { to: backLink, children: `${txt('backToPage')} ${backName}` })] })) }) }));
export default MissingSubpage;
